<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Kết quả thi</h2>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <div>
            Tổng số: <strong>{{ table.pagination.total }}</strong> kết quả thi
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
          width="40"
            type="index"
            label="#">
          </el-table-column>
          <el-table-column
            label="Tên bài">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Khóa học">
            <template slot-scope="scope">
              <span>{{ scope.row.course_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Học viên">
            <template slot-scope="scope">
                <span>{{ scope.row.user_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            label="Điểm thi">
            <template slot-scope="scope">
                <span>{{ scope.row.score }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Kết quả">
            <template slot-scope="scope">
                <div v-if="scope.row.score_status == 2" class="item_active">
                  <span>{{ scope.row.score_status_txt }}</span>
                </div>
                <div v-if="scope.row.score_status == 1">
                  <span>{{ scope.row.score_status_txt }}</span>
                </div>
                <div v-if="scope.row.score_status == 0">
                  <span style="color: #f39c12">{{ scope.row.score_status_txt }}</span>
                </div>
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="Ngày tạo">
            <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
            </template>
          </el-table-column>
<!--           <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column> -->
<!--           <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column
            width="180"
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <!-- <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip> -->
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Kết quả thi'"
      :visible.sync="dialogVisible"
      top="20px"
      width="65%">
      <div>
        <el-row :gutter="20">
          <el-col :span="16">
            <div class="test-list-result">
              <div class="item-question" v-for="(question, indexQuestion) in modelData.list_results" :key="indexQuestion">
                <div>
                  <strong>Câu {{ indexQuestion + 1 }} : </strong>
                  <strong v-html="question.text"></strong>
                </div>
                <div class="list-options test-options" v-if="modelData.type_question == 1">
                  <el-checkbox-group v-model="question.model_option">
                    <el-checkbox :label="option.id" v-for="(option,index) in question.options.data" :key="option.id">
                        <span>{{ returnTitle(index) }}</span>
                        {{ option.text }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="list-options test-options mb-2" v-if="modelData.type_question == 2">
                    <div class="file-upload-done pb-2 d-flex align-items-center" v-if="question.model_option.length">
                        <i class="far fa-file-alt"></i>
                        <span class="name">{{ question.model_option_name }}</span>
                        <i class="far fa-clock"></i>
                        <span class="time">{{ question.model_option_time }}</span>
                        <i class="far fa-eye"></i>
                        <a :href="question.model_option" target="_blank" class="view">Xem</a>
                    </div>
                    <div v-else>
                        <i>- Không có câu trả lời</i>
                    </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="test-info">
              <div>
                <strong>Tên đề thi:</strong>
                <span>{{ modelData.name }}</span>
              </div>
              <div>
                <strong>Khóa học:</strong>
                <span>{{ modelData.course_name }}</span>
              </div>
              <div>
                <strong>Học viên :</strong>
                <span>{{ modelData.user_name }}</span>
              </div>
              <div>
                <strong>Tổng số câu hỏi :</strong>
                <span>{{ modelData.total_question }}</span>
              </div>
              <div>
                <strong>Tổng số câu trả lời :</strong>
                <span>{{ modelData.total_answer }}</span>
              </div>
              <div>
                <strong>Tổng số câu trả lời đúng:</strong>
                <span>{{ modelData.total_success }}</span>
              </div>
              <div>
                <strong>Điểm số:</strong>
                <span>{{ modelData.score }} điểm</span>
              </div>
              <div>
                <strong>Đạt điều kiện vượt qua bài kiểm tra:</strong>
                <span>{{ modelData.score_status_txt }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">Cancel</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Lesssons',
  props: {
    user_id: Number
  },
  data () {
    return {
      loading: false,
      filter: {
        q: '',
        status: '',
        user_id: '',
        test_kit_id: '',
        class_pro_id: '',
        page: 1,
        limit: 100,
        sort: '',
        sorted: '',
        include: ''
      },
      dialogVisible: false,
      modelData: {
        name: '',
        email: '',
        user_id: 0,
        money: 5000000
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        }
      }
    }
  },
  mounted () {
    this.filter.user_id = this.user_id
    if (this.$route.params.id) {
      this.filter.class_pro_id = this.$route.params.id
    }
    this.fetchDatabaseModel()
  },
  methods: {
    returnTitle (index) {
      if (index === 0) return 'A.'
      if (index === 1) return 'B.'
      if (index === 2) return 'C.'
      if (index === 3) return 'D.'
    },
    ...mapActions(['setBreadcrumb']),
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'test-results-create', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Nút tạo Model
    createModelTestKit () {
      this.$router.push({name: 'test-kits-create', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('test-results', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      this.dialogVisible = true
      this.modelData = model
    },
    updateModel (model) {
      this.$router.push({name: 'test-results-update', params: {lesson_id: model.id, course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('test-results/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa kết quả thi bài học: ' + model.name + ' của ' + model.user_name + ' ?', 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('test-results/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
  .test-list-result {
    height: 500px;
    overflow-y: scroll;
  }

  /*// Copy từ con web*/
  .course-test {
    min-height: 100vh;
  }
  .test-content {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .name-company {
    max-width: 200px;
    text-align: left;
  }
  .name-company .name {
    text-transform: uppercase;
    font-weight: bold;
  }
  .name-company-mobile {
    width: 100%;
  }

  .name-company-mobile .name {
    text-transform: uppercase;
    font-weight: bold;
  }
  @media screen and (min-width: 768px) {
    .name-company .name {
      font-size: inherit;
    }
   .name-company .name-2 {
      min-height: 40px;
   }
  }
  .name-test-kit {
    text-align: right;
    max-width: 200px;
    margin-left: 15px;
  }
  @media screen and (min-width: 375px) {
    .name-test-kit {
      text-align: right;
      max-width: 250px;
    }
  }
  @media screen and (min-width: 768px) {
    .name-test-kit {
      max-width: 480px;
    }
  }
  .name-test-kit .name {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: bold;
  }
  @media screen and (min-width: 768px) {
    .name-test-kit .name {
      font-size: 15px;
    }
  }
  .name-test-kit .hold {
    text-transform: initial;
  }

  .item-question {
    margin-top: 15px;
  }
  .list-options .form-check {
    margin: 8px 0px;
  }
  .list-options .form-check input,
  .list-options .form-check label {
    cursor: pointer !important;
  }

  .test-info-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 15px;
  }
  .test-info {
    margin-top: 15px;
    padding: 15px;
    border-radius: 2px;
    background-color: #f2f2f2;
  }

  .test-options {

  }
  .test-options .el-radio-group {
    display: flex;
    flex-direction: column;
  }
  .test-options .el-radio {
    margin-left: 0px !important;
    line-height: 25px;
  }
  .test-options .el-radio:hover {
    color: #28A90C !important;
  }

  .test-kit-done {
    background-color: #f8f8f8;
    padding: 10px;
  }
</style>

<style>
  .test-list-result .el-radio {
    white-space: inherit;
    margin-bottom: 7px;
    line-height: 20px;
  }
  .el-input__icon {
      line-height: 25px !important;
  }

  .el-checkbox-group {
      display: flex;
      flex-direction: column;
  }
  .el-checkbox {
      margin-left: 0px !important;
      line-height: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/test-results/Index.vue